export interface TableBodyProps {
    children;
}

const TableBody = ({ children }: TableBodyProps) => children;

export default TableBody;
